import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {InsightsIndexComponent} from '../insights-index/insights-index.component';
import {InsightsContentYouCreateComponent} from '../insights-content-you-create/insights-content-you-create.component';
import {InsightsDetailsComponent} from '../insights-details/insights-details.component';
import {DatePipe, NgIf} from '@angular/common';
import {InsightsDatepickerModule} from "../insights-datepicker/insights-datepicker.module";
import {InsightsDateFilterEnums} from "../../../../enums/profile-enums";
import {subDays, subMonths} from "date-fns";
import {DateRangePipe} from "../../../../pipes/date-range/date-range.pipe";
import { TranslateModule } from '@ngx-translate/core';
import {InsightsSingleListComponent} from "../insights-single-list/insights-single-list.component";

@Component({
  selector: 'tl-insights',
  standalone: true,
  imports: [
    InsightsIndexComponent,
    InsightsContentYouCreateComponent,
    InsightsDetailsComponent,
    NgIf,
    InsightsDatepickerModule,
    DateRangePipe,
    TranslateModule,
    InsightsSingleListComponent
  ],
  templateUrl: './insights.component.html',
  providers: [DatePipe]
})
export class InsightsComponent implements OnInit, OnChanges {
  @Input() isInsightsIndexPage = true;
  @Output() onChangePage: EventEmitter<void> = new EventEmitter();
  isDatepickerModalOpen = false;
  selectedDate = new Date();
  selectedFilter = InsightsDateFilterEnums.lastSevenDays;
  selectedListId: any;
  viewAllList = false;
  selectedDetailsType = '';
  urlParams: {from_date: string | null, to_date: string | null} = {from_date: null, to_date: null};
  constructor(private datePipe: DatePipe) {
  }

  ngOnInit(): void {
    this.onChangeDateOrFilter({selectedFilter: this.selectedFilter, selectedDate: this.selectedDate});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isInsightsIndexPage && changes.isInsightsIndexPage.currentValue) {
      this.selectedListId = null;
      this.selectedDetailsType = '';
      this.viewAllList = false;
    }
  }

  onChangeDateOrFilter(event: any): void {
    this.selectedFilter = event.selectedFilter;
    this.selectedDate = event.selectedDate;
    this.urlParams.to_date = this.datePipe.transform(event.selectedDate, 'yyyy-MM-dd');
    switch (event.selectedFilter) {
      case InsightsDateFilterEnums.lastSevenDays:
        this.urlParams.from_date = this.datePipe.transform(subDays(event.selectedDate, 6), 'yyyy-MM-dd');
        break;
      case InsightsDateFilterEnums.lastThirtyDays:
        this.urlParams.from_date = this.datePipe.transform(subDays(event.selectedDate, 29), 'yyyy-MM-dd');
        break;
      case InsightsDateFilterEnums.lastThreeMonths:
        this.urlParams.from_date = this.datePipe.transform(subMonths(event.selectedDate, 3), 'yyyy-MM-dd');
        break;
      case InsightsDateFilterEnums.lastNineMonths:
        this.urlParams.from_date = this.datePipe.transform(subMonths(event.selectedDate, 9), 'yyyy-MM-dd');
        break;
      case InsightsDateFilterEnums.lastYear:
        this.urlParams.from_date = this.datePipe.transform(subMonths(event.selectedDate, 12), 'yyyy-MM-dd');
        break;
      default:
        this.urlParams.from_date = this.datePipe.transform(subDays(event.selectedDate, 6), 'yyyy-MM-dd');
    }
    this.urlParams = {...this.urlParams};
    this.isDatepickerModalOpen = false;
  }
}
